import * as React from "react";
import { Card } from "@mui/material";
const Section = ({children,sx,...props}) => {
    return (<Card  {...props} sx={{px:5,py:3,mt:4,...sx}}>{children}</Card>)
}
export default Section
